import { render, staticRenderFns } from "./SnowSteps.vue?vue&type=template&id=2448f458&scoped=true&"
import script from "./SnowSteps.vue?vue&type=script&lang=js&"
export * from "./SnowSteps.vue?vue&type=script&lang=js&"
import style0 from "./SnowSteps.vue?vue&type=style&index=0&id=2448f458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2448f458",
  null
  
)

export default component.exports